var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-list-group-item",
    {
      staticClass: "equipment-item my-2",
      attrs: { button: "", disabled: _vm.isDisabled },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.click.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "loader d-flex" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-row mr-3 align-items-center" },
                  [_c("loading-spinner", { attrs: { size: 15 } })],
                  1
                ),
                _vm._v(" "),
                _c("span", { domProps: { innerHTML: _vm._s(_vm.name) } })
              ])
            : _c(
                "b-form-checkbox",
                { attrs: { checked: _vm.active, disabled: _vm.isDisabled } },
                [
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.name) } }),
                  _vm._v(" "),
                  _vm.option.selectionState === "REQUIRED"
                    ? _c("i", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "ion-ios-information",
                        attrs: {
                          title: "Required by another selection",
                          "aria-hidden": "true"
                        }
                      })
                    : _vm.option.selectionState === "EXCLUDED"
                    ? _c("i", {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "ion-ios-minus",
                        attrs: {
                          title: "Another option has excluded this option",
                          "aria-hidden": "true"
                        }
                      })
                    : _vm._e()
                ]
              ),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "price" }, [
              _vm.option.priceState === "UNKNOWN"
                ? _c("span", { staticClass: "dealer-pricing" }, [
                    _vm._v(
                      "\n                    See Dealer For Pricing\n                "
                    )
                  ])
                : _vm.option.msrp && !_vm.isIncluded
                ? _c("span", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm._f("numeral")(_vm.option.msrp, "$0,0")) +
                        "\n                "
                    )
                  ])
                : (_vm.option.msrp && _vm.isIncluded) || _vm.isIncluded
                ? _c("span", [
                    _vm._v("\n                    Inc.\n                ")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            !_vm.isDisabled
              ? _c("div", { staticClass: "icon" }, [
                  _vm.extended
                    ? _c("i", {
                        class: _vm.showExpanded
                          ? "ion-chevron-down"
                          : "ion-chevron-up",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            _vm.showExpanded = !_vm.showExpanded
                          }
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.extended
        ? _c(
            "b-collapse",
            {
              staticClass: "mt-2",
              attrs: { id: "option-extended-" + _vm.option.chromeOptionCode },
              model: {
                value: _vm.showExpanded,
                callback: function($$v) {
                  _vm.showExpanded = $$v
                },
                expression: "showExpanded"
              }
            },
            [
              _c("div", {
                staticClass: "py-3 px-4 m-0",
                domProps: { innerHTML: _vm._s(_vm.extended) }
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }